// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure_figure__ot9u2","author":"Figure_author__ZZEuB"};